export const siteKey = window.ENV.RECAPTCHA;
